module.exports = __webpack_public_path__ + "img/2@2x (2).d9f2d1dc.png";